/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1LocationStatesMutationRequest,
  PostApiV1LocationStatesMutationResponse,
  PostApiV1LocationStates400,
  PostApiV1LocationStates401,
  PostApiV1LocationStates404,
  PostApiV1LocationStates409,
  PostApiV1LocationStates500,
} from "../../types/locationStateController/PostApiV1LocationStates.ts";

function getPostApiV1LocationStatesUrl() {
  const res = { method: "POST", url: `/api/v1/location/states` as const };
  return res;
}

/**
 * @description Cria um novo estado vinculado a um país. A sigla e o nome devem ser únicos. **(Requer Authorization para autenticação)**
 * @summary Criar estado (Requer Authorization para autenticação)
 * {@link /api/v1/location/states}
 */
export async function postApiV1LocationStates(
  data?: PostApiV1LocationStatesMutationRequest,
  config: Partial<RequestConfig<PostApiV1LocationStatesMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1LocationStatesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationStates400
      | PostApiV1LocationStates401
      | PostApiV1LocationStates404
      | PostApiV1LocationStates409
      | PostApiV1LocationStates500
    >,
    PostApiV1LocationStatesMutationRequest
  >({
    method: "POST",
    url: getPostApiV1LocationStatesUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
